<template>
    <div>
        <Nav></Nav>
        <PageHeader :linkto="'/Master'" :linkttitle="'返回'" :title="productName"></PageHeader>
        <b-container v-if="pageview">
            <ScoreResultCard title="整體勝敗分析" :score="anaResult.score" :listdata="anaResult.explantion"></ScoreResultCard>
            <MasterResultCard v-for="(item , index) in anaResult.source.manedata" v-bind:key="index" :name="item.name" :listdata="[]" v-on:sendAction="PaymentPopup"></MasterResultCard>
        </b-container>
        <b-container v-else>
            <b-button class="my-3" variant="primary" block to="/Master">重新分析高手過招</b-button>
        </b-container>

        <PaymentModel :product="productName" :point="Price" v-on:sendAction="GoPayment"></PaymentModel>
        <AnaLoading way="Normal" :show="pageloading"></AnaLoading>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'
import ScoreResultCard from '@/components/ScoreResultCard.vue'
import MasterResultCard from '@/components/MasterResultCard.vue'

import PaymentModel from '@/components/PaymentModel.vue'
import AnaLoading from '@/components/AnaLoading.vue'
import {alertModel} from '@/service/commuse'

export default {
  name: 'MasterResult',
  components: {Nav,PageHeader,PaymentModel,ScoreResultCard,MasterResultCard,AnaLoading},
  data () {
    return {
      productName:'高手過招',
      formData: {},
      pageloading:false,
      puid:'9'
    }
  },
  computed:{
    ...mapState(['anaResult','productdata']),
    Price:function () {return this.productdata.data.find(x => x.id === this.puid).price},
    pageview:function () {return Object.keys(this.anaResult).length === 0 ? false: true;},

  },
  mounted(){
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  },
  methods: {

    PaymentPopup (data) {
      this.formData = data

      this.$store.dispatch('actionGetCurencyPlan', {})
        .then((res) => {
          if(res.data.point == 9999999){
            this.GoPayment()
          }else{
            this.$bvModal.show('PaymentModel')
          }
        }).catch((res) => {
        this.$bvModal.show('PaymentModel')
      });
    },
    GoPayment () {

      this.pageloading = true
      this.$store.dispatch('actionAnaResult', {
        manedata: this.anaResult.source.manedata,
        producttype:'MasterResult'
      }).then((res) => {

        setTimeout(()=>{
          this.pageloading = false
          this.$router.push('/MasterVipResult');
        },3000)
      }).catch((res) => {
        this.pageloading = false

        alertModel(this,'系統訊息','點數餘額不足')
      });
    }


  }
}
</script>

<style scoped>

</style>
